import { Trait } from '../../trait.type';
import { ModifierPriority } from '../../modifier.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { dealDamage } from '../../player.type';

export class FencerTrait extends Trait {
  static baseType = TraitType.Fencer;
  static baseTitle = "Fencer's Riposte";
  static baseText = 'When attacked for 0 damage, deal 1 damage.';
  static baseIcon = 'trait';

  type = FencerTrait.baseType;
  title = FencerTrait.baseTitle;
  text = FencerTrait.baseText;
  icon = FencerTrait.baseIcon;

  init() {
    this.priority = ModifierPriority.Last;
  }

  damageIn(damage: any): void {
    if (damage.value == 0) {
      dealDamage({ value: 1, target: damage.source, source: damage.target, dice: [] });
    }
  }
}

TraitRegistry.register(FencerTrait.baseType, FencerTrait);
